module.exports = __webpack_public_path__ + "img/horizontal_4_7_3009.c1e111fa.png";